/* ==========================================================================
   Maccs — price sync
   Owns the big price, the frequency card prices, and the Add to Cart total.
   Envy's update_variant() resets the button label and #price-field on every
   variant change, so everything here runs after it via setTimeout(0).

   Oct 2026: member pricing removed. One price for everyone; the frequency
   cards show their own allocation price and the big price follows the
   selected plan.
   ========================================================================== */

(function () {
  'use strict';

  var button = document.getElementById('purchase');
  var json = document.querySelector('[id^="ProductJson-"]');
  var select = document.querySelector('select.original-select');
  var priceField = document.getElementById('price-field');
  var qtyInput = document.getElementById('Quantity');
  if (!button || !json || !select) return;

  var product;
  try { product = JSON.parse(json.textContent); } catch (e) { return; }

  var baseLabel = (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Add to Cart';
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  function currentVariant() {
    var id = parseInt(select.value, 10);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return null;
  }

  function selectedPlanId() {
    var checked = document.querySelector('input[name="selling_plan"]:checked');
    return checked && checked.value ? String(checked.value) : '';
  }

  /* Allocation price for a plan, or the plain variant price when none. */
  function priceFor(variant, planId) {
    if (!variant) return 0;
    if (planId && variant.selling_plan_allocations) {
      for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
        var a = variant.selling_plan_allocations[i];
        if (String(a.selling_plan_id) === planId) return a.price;
      }
    }
    return variant.price;
  }

  function quantity() {
    var n = parseInt(qtyInput && qtyInput.value, 10);
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function update() {
    var variant = currentVariant();
    if (!variant) return;

    /* Each frequency card shows its own price for the current variant. */
    var radios = document.querySelectorAll('input[name="selling_plan"]');
    Array.prototype.forEach.call(radios, function (radio) {
      var target = radio.parentNode.querySelector('[data-mx-freq-price]');
      if (target) {
        target.textContent = formatMoney(priceFor(variant, radio.value ? String(radio.value) : ''));
      }
    });

    var unit = priceFor(variant, selectedPlanId());

    /* Box selector (Variety Pack template): it sets the order total itself,
       since the 3 and 5 dozen prices come from automatic discounts. */
    var bundle = document.querySelector('[data-mx-bundle]');
    var bundleTotal = bundle ? parseInt(bundle.getAttribute('data-total-cents'), 10) : NaN;
    var bundleSuffix = bundle ? (bundle.getAttribute('data-suffix') || '') : '';
    var total = isNaN(bundleTotal) ? unit * quantity() : bundleTotal;

    /* Big price: the plan-adjusted unit, or the box total on the Variety Pack */
    if (priceField && variant.available) {
      priceField.innerHTML = '<span class="money">' + formatMoney(bundle ? total : unit) + bundleSuffix + '</span>';
    }

    if (!button.disabled && variant.available) {
      button.textContent = baseLabel + ' \u00b7 ' + formatMoney(total) + bundleSuffix;
    }
  }

  var $ = window.jQuery;
  if ($) $(document).on('variantAvailable', function () { setTimeout(update, 0); });

  select.addEventListener('change', function () { setTimeout(update, 0); });

  document.addEventListener('change', function (e) {
    if (e.target.name === 'selling_plan') update();
    if (e.target.closest && e.target.closest('.mx-pack')) setTimeout(update, 0);
  });

  if (qtyInput) {
    qtyInput.addEventListener('change', update);
    var controls = qtyInput.closest('.quantity-controls');
    if (controls) controls.addEventListener('click', function () { setTimeout(update, 0); });
  }

  update();
})();